'use client';

import { atom } from 'jotai';

export type AccModalSource = 'saved-search';

export const accModalSourceAtom = atom<string | AccModalSource | undefined>(undefined);
